import { Checkbox, FormControlLabel, SxProps, Theme } from "@mui/material";

type Props = {
    label: string;
    value: boolean;
    onChange: (value: boolean) => void;
    sx?: SxProps<Theme>;
    size?: "small" | "medium" | "large";
};

export default function CheckboxInput({ label, value, onChange, sx, size = "small" }: Props) {
    return (
        <FormControlLabel
            label={label}
            control={<Checkbox checked={value} onChange={e => onChange(e.target.checked)} size={size} />}
            sx={sx}
        />
    );
}
